module.exports = __webpack_public_path__ + "assets/images/045d706401840e2a0a4d61ab620e0bc2.svg";